import { VueI18nHelper } from '@/helpers/VueI18nHelper';
import Header from './Header.vue';
import '../../assets/styles/rin-global.less';
import '../../assets/styles/rin-table.less';
import '../../assets/styles/rin-settings.less';
import config from '../../../config';

VueI18nHelper.initVueI18NextForPage(Header, `.header-vue`, [
  config.locize.webshopWordpress.namespaces.CART,
  config.locize.webshopWordpress.namespaces.SEARCH,
  config.locize.webshopWordpress.namespaces.HEADER,
  config.locize.webshopWordpress.namespaces.MENU,
  config.locize.webshopWordpress.namespaces.MYPROFILE,
]);
